import { decryptedValue } from 'common/utility';
import ToastDialog from 'components/Common/ToastDialog';
import { addlistingPreference, getlistingPreference } from 'http/fundLync/listingPreferenceHelper';
import React, { useState, useEffect } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { AiFillDelete } from 'react-icons/ai';
import { Button } from 'reactstrap';

const ItemTypes = {
    COLUMN: 'column'
};

const DraggableColumn = ({ column, index, onRemove, showRemove, moveColumn }) => {
    const [{ isDragging }, drag] = useDrag(() => ({
        type: ItemTypes.COLUMN,
        item: { column, index },
        collect: (monitor) => ({
            isDragging: !!monitor.isDragging(),
        }),
    }));

    const [, drop] = useDrop({
        accept: ItemTypes.COLUMN,
        hover: (draggedItem) => {
            if (draggedItem.index !== index) {
                moveColumn(draggedItem.index, index);
                draggedItem.index = index; 
            }
        },
    });

    return (
        <div
            ref={(node) => drag(drop(node))}
            style={{
                opacity: isDragging ? 0.5 : 1,
                padding: '8px',
                margin: '4px',
                backgroundColor: '#f0f0f0',
                cursor: 'move',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                position: 'relative', 
            }}
        >
            {column.Header}
            {showRemove && (
                <AiFillDelete
                    className="delete-icon"
                    style={{
                        cursor: 'pointer',
                        color: 'rgb(167, 167, 167)',
                    }}
                    onClick={() => onRemove(column)}
                />
            )}
        </div>
    );
};


const DroppableContainer = ({ selectedColumns, setSelectedColumns, tableType }) => {
    const [toastInfo, setToastInfo] = useState({
        message: "",
        showToast: false,
        role: "",
    });

    const [, drop] = useDrop({
        accept: ItemTypes.COLUMN,
        drop: (item) => handleDrop(item.column),
    });

    const moveColumn = (dragIndex, hoverIndex) => {
        const updatedColumns = [...selectedColumns];
        const [movedColumn] = updatedColumns.splice(dragIndex, 1);
        updatedColumns.splice(hoverIndex, 0, movedColumn);
        setSelectedColumns(updatedColumns);
    };

    const handleDrop = (droppedColumn) => {
        if (!selectedColumns.some(col => col?.accessor === droppedColumn?.accessor)) {
            setSelectedColumns([...selectedColumns, droppedColumn]);
        }
    };
    const user = decryptedValue(localStorage.getItem("user"));
    const handleClearAll = () => {
        setSelectedColumns([]);
        const data = {
            userId: user.id,
            tableType: tableType,
            columnData: [],
        };
        addlistingPreference(data)
            .then((response) => {
                if (response.code == 201 && response.status) {
                    setToastInfo({
                        message: "User Preference Removed",
                        showToast: true,
                        role: "success",
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                } else {
                    const { message } = response;
                    setToastInfo({
                        message: message,
                        showToast: true,
                        role: "error",
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const handleRemove = (columnToRemove) => {
        if (selectedColumns.length === 1 && selectedColumns[0]?.accessor === columnToRemove?.accessor) {
            handleClearAll();
        } else {
            setSelectedColumns(selectedColumns.filter(col => col?.accessor !== columnToRemove?.accessor));
        }
    };
    



    return (
        <div
            ref={drop}
            style={{
                minHeight: '300px',
                padding: '16px',
                border: '2px dashed #cccccc',
                backgroundColor: '#fafafa',
                position: 'relative',
                display: selectedColumns.length === 0 ? 'flex' : '',
                flexDirection: 'column',
                alignItems: selectedColumns.length === 0 ? 'center' : 'right',
                justifyContent: selectedColumns.length === 0 ? 'center' : 'flex-start',
            }}
        >
            {selectedColumns.length === 0
                ? <p>Drag columns here</p>
                : selectedColumns.map((col, index) => (
                    <DraggableColumn
                        key={col?.accessor}
                        index={index}
                        column={col}
                        onRemove={handleRemove}
                        showRemove={true}
                        moveColumn={moveColumn}
                    />
                ))}
            <ToastDialog
                message={toastInfo.message || ""}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            ></ToastDialog>
        </div>
    );
};


const ColumnDragDrop = ({ columns, onApply, toggleModal, tableType }) => {
    const [selectedColumns, setSelectedColumns] = useState([]);
    const user = decryptedValue(localStorage.getItem("user"));
    const [toastInfo, setToastInfo] = useState({
        message: "",
        showToast: false,
        role: "",
    });

    useEffect(() => {
        getlistingPreference({ userId: user.id, tableType })
            .then((response) => {
                if (response.code == 200 && response.status) {
                    const apiColumns = response.data?.columnData || [];

                    const mappedColumns = apiColumns.map((apiColumn) => {
                        const matchedColumn = columns.find(col => col?.accessor === apiColumn?.accessor);
                        if (matchedColumn) {
                            return {
                                ...matchedColumn,
                                ...apiColumn,
                            };
                        }
                        return apiColumn;
                    });
                    setSelectedColumns(mappedColumns);
                } else {

                    setSelectedColumns([])
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }, [])
    

    const handleApply = () => {
        
        const updatedColumns = selectedColumns.map((column, index) => ({
            ...column,
            hideOrder: index + 1 
        }));
        const data = {
            userId: user.id,
            tableType: tableType,
            columnData: updatedColumns,
        };
        if(selectedColumns.length > 0){
            toggleModal()
            addlistingPreference(data)
              .then((response) => {
                  if (response.code == 201 && response.status) {
                      setToastInfo({
                          message: "User Preference saved",
                          showToast: true,
                          role: "success",
                      });
                      setTimeout(() => {
              window.location.reload();
          }, 500);
                  } else {
                      const { message } = response;
                      setToastInfo({
                          message: message,
                          showToast: true,
                          role: "error",
                      });
                  }
              })
              .catch((err) => {
                  console.log(err);
              });
            
          }else{
              setToastInfo({
                  message: "please drag atleast one column",
                  showToast: true,
                  role: "error",
              });
          }
    };
    const availableColumns = columns.filter(col => {
        return !selectedColumns.some(selectedCol => selectedCol?.accessor === col?.accessor);
    });

    const handleClearAll = () => {
        setSelectedColumns([]);
        const data = {
            userId: user.id,
            tableType: tableType,
            columnData: [],
        };
        addlistingPreference(data)
            .then((response) => {
                if (response.code == 201 && response.status) {
                    setToastInfo({
                        message: "User Preference Removed",
                        showToast: true,
                        role: "success",
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                } else {
                    const { message } = response;
                    setToastInfo({
                        message: message,
                        showToast: true,
                        role: "error",
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });


    };
    return (
        <div className="d-flex flex-column">
            <div className="d-flex justify-content-between mb-2">
                <div className="available-columns" style={{ width: '45%' }}>
                    <h5 style={{ textAlign: "left" }}>Available Columns</h5>
                    <div style={{ padding: '16px', border: '1px solid #ddd', minHeight: '300px' }}>
                       
                        {availableColumns.map((col, index) => (
                            <DraggableColumn key={col?.accessor} column={col} index={index} onRemove={() => { }} moveColumn={() => { }} />
                        ))}
                    </div>
                </div>


                <div className="selected-columns " style={{ width: '45%', position: 'relative' }}>
                    <h5 style={{ textAlign: "left" }}>Selected Columns</h5>
                    <DroppableContainer selectedColumns={selectedColumns} setSelectedColumns={setSelectedColumns} tableType={tableType}/>
                    <div className="d-flex justify-content-end">
                        {selectedColumns.length > 0 && (
                            <Button
                                type="button"
                                color="light"
                                className="btn-rounded mb-2 me-2 ms-2 border-success"
                                onClick={handleClearAll}
                                style={{
                                    bottom: '0px',
                                    right: '10px',
                                    marginTop: "10px"
                                }}
                            >
                                Clear All
                            </Button>
                        )}
                        <Button
                            type="button"
                            color="success"
                            className="btn-rounded mb-2 me-2"
                            onClick={handleApply}
                            style={{
                                // position: 'absolute',
                                bottom: '0px',
                                right: '10px',
                                marginTop: "10px"
                            }}
                        >
                            Apply
                        </Button>
                    </div>
                </div>
            </div>
            <ToastDialog
                message={toastInfo.message || ""}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            ></ToastDialog>
        </div>


    );
};




export default ColumnDragDrop;